import { TextInput } from '@components/shared/TextInput'
import { MdOutlineDelete } from 'react-icons/md'

const GrantorRow = ({
    index,
    data,
    handleChange,
    handleRowDelete,
}) => {
    
    { /* @todo this can prob just be a table */ }
    
    return (
        
        <div className="join">
            <TextInput
                className="w-full"
                name="name"
                inputClassName="w-full join-item"
                value={(data?.name) ?? ''}
                handleChange={handleChange}
                placeholder="" />
            
            <button
                type="button"
                className="btn join-item !px-3"
                onClick={() => handleRowDelete(index)}>
                <MdOutlineDelete className="text-lg" />
            </button>
        </div>
    )
}

export default GrantorRow
